export const PREFERENCES_CHECKBOXES = [
  {
    label: "Straight",
    name: "straight",
    value: "straight",
    isChecked: false
  },
  {
    label: "Gay",
    name: "gay",
    value: "gay",
    isChecked: false
  },
  {
    label: "Lesbian",
    name: "lesbian",
    value: "lesbian",
    isChecked: false
  },
  {
    label: "Trans",
    name: "trans",
    value: "trans",
    isChecked: false
  },
  {
    label: "Animated",
    name: "animated",
    value: "animated",
    isChecked: false
  },
  {
    label: "Bisexual",
    name: "bisexual",
    value: "bisexual",
    isChecked: false
  },
];
